import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PRICE_GUIDE_URL } from "../../utils/urls";
import instance from "../../services/services";
import useUserStore from "../../store/userStore";
import PopupLoginError from "../../components/Popup/LoginError";
import { INSTRUCTION_DATA_URL } from "../../utils/urls";
import { useLanguage } from "../../hooks/useLanguage";

function PriceGuarantee(){
  const { t } = useLanguage();
    const navigate = useNavigate();
    const [questionList, setQuestionList] = useState([]);
    const { memberTokens } = useUserStore();
    const [isPopupLoginError, setIsPopupLoginError] = useState(false);
    const [instructionData, setInstructionData] = useState([]);

    useEffect(()=> {
      const fetchInstructionData = async () => {
        try {
          const response = await instance.post(INSTRUCTION_DATA_URL);
          setInstructionData(response.data.data.data);
        } catch (error) {
          console.error('이용안내 데이터 가져오기 실패:', error); 
        }
      };
      fetchInstructionData();
    }, []);

    const handleClickForm = () => {
        if (!memberTokens) {
            setIsPopupLoginError({
                message: t('login_required'),
                action: 'navigate_login'
            });
            return;
        }
        navigate('/community/priceGuarantee/write');
    };

    const handleConfirm = () => {
        navigate('/login');
    };
  

  // 최저가 보장 가이드
  useEffect(() => {
    const fetchQuestionList = async () => {
      try {
        const response = await instance.post(PRICE_GUIDE_URL);
        setQuestionList(response.data.data);

      } catch (error) {
        console.error("1:1문의 목록 가져오기실패:", error);
      }
    };
    fetchQuestionList();
  }, []);

    
  return(
    <div className="board_container">
      <h3 className="commu_title noline">{t("lowest_price_guarantee")}</h3>

      <div className="commu_box btm_btn_box">
        <div className="column flex-8">
          <h4 className="p2">{t("daypay_with_you_0617")}</h4>
          <p className="g-80 b1_2">
            {t("daypay_1_1_inquiry")}<br/>
            {t("camera_rental_related")}
          </p>
        </div>
        <button 
          type="button" 
          className="default_btn black"
          onClick={handleClickForm}
        >
          {t("report3")}
        </button>
      </div>
      <div>
        <div className="board_container guarantee_con mt_32 unset_box">
              <div dangerouslySetInnerHTML={{ __html: questionList?.apply_method_desc }}></div>

        </div>

        <div className="board_container guarantee_con mt_32 unset_box">
              <div dangerouslySetInnerHTML={{ __html: questionList?.terms }}></div>
        </div>
      </div>
      <div className="reason_container">
          <h3 className="commu_title noline">{t('daypay_reason')}</h3>
          <div className="reason_inner">
            <ul className="reason_con">
              {instructionData.map((item, index) => (
                <li key={index}>
                  <img src={item.icon_image_url} alt="cart" loading="lazy"/>
                  <div className="reason_txt">
                    <p>{item.subject}</p>
                    <span className="g-90">
                      {item.content}
                  </span>
                </div>
                {item.btn_link_url && (
                <button
                  type="button"
                  className="reason_btn"
                  onClick={() => {
                    if (item.btn_link_url.startsWith('http')) {
                      window.open(item.btn_link_url, '_blank');
                    } else {
                      navigate(item.btn_link_url);
                    }
                  }}
                >
                  {item.btn_link_name}
                  </button>
                )}
                </li>
              ))}
            </ul>
          </div>
        </div>

      <PopupLoginError 
        isPopup={isPopupLoginError} 
        setIsPopup={setIsPopupLoginError}
        onConfirm={handleConfirm}
      />

    </div>
  )
};

export default PriceGuarantee;